import { GoogleOAuthProvider } from '@react-oauth/google'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { GOOGLE_CLIENT_ID } from '../config/env'
import AppProvider from '../context/AppProvider'
import { persistor, store } from '../redux/store'
import Router from './Router'
import ToastProvider from './ToastProvider'

const AppTree = () => (
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <ToastProvider>
                <AppProvider>
                    <Router />
                </AppProvider>
            </ToastProvider>
        </PersistGate>
    </Provider>
)

const App = () => {
    return GOOGLE_CLIENT_ID ? (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <AppTree />
        </GoogleOAuthProvider>
    ) : (
        <AppTree />
    )
}

export default App